import { amplitudeAnalytics } from './analytics';
import { amplitudeExperiment } from './experiment';

export default {
    install(app) {
        app.prototype.$amplitudeAnalytics = amplitudeAnalytics;
        app.prototype.$amplitudeExperiment = amplitudeExperiment;
    },
}